import { Carousel as ACarousel, useCarouselContext } from '@ark-ui/solid/carousel';
import { IconChevronLeft } from '@bbr/brand/chevron-left';
import { IconChevronRight } from '@bbr/brand/chevron-right';
import { splitProps } from 'solid-js';
import { cn } from 'tailwind-variants';
import { Button } from '../forms/button.tsx';
import type { ComponentProps } from 'solid-js';

export function Carousel(props: ComponentProps<typeof ACarousel.Root> & { prevLabel: string; nextLabel: string }) {
	const [, spread] = splitProps(props, ['children', 'prevLabel', 'nextLabel']);
	return (
		<ACarousel.Root spacing="1rem" autoSize allowMouseDrag class="relative rounded-lg" {...spread}>
			{props.children}
			<CarouselControls prevLabel={props.prevLabel} nextLabel={props.nextLabel} />
		</ACarousel.Root>
	);
}

function CarouselControls(props: { prevLabel: string; nextLabel: string }) {
	const carousel = useCarouselContext();

	return (
		<>
			<div
				class="absolute -inset-y-4 inset-s-0 w-6 bg-linear-90 from-white to-white/0 dark:from-zinc-900 dark:to-zinc-900/0"
				classList={{ 'opacity-0': !carousel().canScrollPrev, 'opacity-100': carousel().canScrollPrev }}
			/>
			<div
				class="absolute -inset-y-4 inset-e-0 w-6 bg-linear-270 from-white to-white/0 dark:from-zinc-900 dark:to-zinc-900/0"
				classList={{ 'opacity-0': !carousel().canScrollNext, 'opacity-100': carousel().canScrollNext }}
			/>
			<ACarousel.Control class="pointer-events-none absolute inset-0 z-10 flex items-center justify-between **:transition-opacity **:disabled:opacity-0 [&_button]:bg-white dark:[&_button]:bg-zinc-900">
				<ACarousel.PrevTrigger
					asChild={(p) => (
						// @ts-expect-error too complex
						<Button
							{...p()}
							rounding="circle"
							size="lg"
							icon={IconChevronLeft}
							iconPosition="only"
							iconLabel={props.prevLabel}
						/>
					)}
				/>
				<ACarousel.NextTrigger
					asChild={(p) => (
						// @ts-expect-error too complex
						<Button
							{...p()}
							rounding="circle"
							size="lg"
							icon={IconChevronRight}
							iconPosition="only"
							iconLabel={props.nextLabel}
						/>
					)}
				/>
			</ACarousel.Control>
		</>
	);
}

Carousel.ItemGroup = function CarouselItemGroup(props: ComponentProps<typeof ACarousel.ItemGroup>) {
	return (
		<ACarousel.ItemGroup
			{...props}
			class={cn('grid auto-cols-max grid-flow-col items-stretch gap-4 py-4', props.class)}
		/>
	);
};

Carousel.Item = function CarouselItem(props: ComponentProps<typeof ACarousel.Item>) {
	return <ACarousel.Item {...props} />;
};
